/* 
Copyright (c) Karsten Jeske and John Firth
This source code is licensed under the proprietary license found in the
LICENSE file in the root directory of this source tree.
*/

import Footer from "components/Footer"
import Navbar from "components/Header"
import { setupPopovers } from "components/InfoPopover"
import About from "pages/About"
import Disclaimers from "pages/Disclaimers"
import Home from "pages/Home"
import NotFound from "pages/NotFound"
import { useEffect } from "react"
import { Route, BrowserRouter as Router, Routes } from "react-router-dom"

const App = () => {
  useEffect(setupPopovers, [])

  return (
    <Router>
      <div className="bg-light min-vh-100 d-flex flex-column justify-content-between">
        <div className="container shadow-sm bg-white rounded my-0 my-sm-5 mb-3 mb-sm-5">
          <Navbar />
          <main className="px-sm-3 px-md-3 pb-2 px-lg-5">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/disclaimers" element={<Disclaimers />} />
              <Route path="*" element={<NotFound />} /> {/* 404 page */}
            </Routes>
          </main>
        </div>
        <Footer />
      </div>
    </Router>
  )
}

export default App
